export default {
  billing: {},
  billingPlans: {},
  billingAddons: {},
  billingCustomer: {},
} as {
  billing:Billing.Subscription,
  billingPlans: {[key: string]: Billing.BillingPlan}
  billingAddons: {[key in keyof BillingLimits]: Billing.BillingAddon}
  billingCustomer: Billing.BillingCustomer,
}